import {SingleInvoice} from "./invoices";

export interface JobSteps {
  stepI: StepI;
  stepII: StepII;
  stepIII: StepIII;
  stepIV: StepIV;
  stepV: StepV;
  stepVI: StepVI;
}

export interface JobDeleteImpact {
  project_id: string;
  job_id: number;
  job_positions: number;
  confirmations: number[];
  notifications: number[];
  orders: number[];
  deliveries: number[];
  invoices: number[];
}
class StepI {
  project_id: string = '';
  job_id: number = 0;
  company_name: string = '';
  department: string = '';
  street: string = '';
  postcode: string = '';
  city: string = '';
  country: string = '';
  name_project: string = '';
  description: string = '';
  job_date: string = '';
  delivery_date: string = '';
  request_id: string = '';
  order_id: string = '';
  status: string = '';
  budget: number = 0;
}

class StepII {
  employee_phm: string = '';
}

class StepIII {
  employee_leader: string = '';
}

class StepIV {
  cond_offer: number = 0;
  cond_payment: number = 0;
  cond_delivery: number = 0;
  delivery_remarks: string = '';
}

class StepV {
  delivery_company: string = '';
  delivery_department: string = '';
  delivery_street: string = '';
  delivery_postcode: string = '';
  delivery_city: string = '';
  delivery_country: string = '';
}

class StepVI {
  invoice_company: string = '';
  invoice_department: string = '';
  invoice_street: string = '';
  invoice_postcode: string = '';
  invoice_city: string = '';
  invoice_country: string = '';
  invoice_vat_id: string = '';
  invoice_leitweg_id: string = '';
  invoice_einvoice_endpoint: string = '';
}

export interface Jobs {
  project_id: string,
  job_id: number,
  offer_id: number,
  company_name: string,
  department?: string,
  street: string,
  city: string,
  postcode: string,
  country: string,
  request_id: string,
  order_id: string,
  job_date: string,
  name_project: string,
  description: string,
  budget: string,
  cond_offer: number,
  cond_payment: number,
  cond_delivery: number,
  delivery_remarks: string,
  delivery_date: string,
  status: string,
  employee_phm: number,
  employee_leader: number,
  technology: boolean,
  delivery_company: string,
  delivery_department?: string,
  delivery_street: string,
  delivery_postcode: string,
  delivery_city: string,
  delivery_country: string,
  invoice_company: string,
  invoice_department?: string,
  invoice_street: string,
  invoice_postcode: string,
  invoice_city: string,
  invoice_country: string,
  invoice_vat_id: string,
  invoice_leitweg_id: string,
  invoice_einvoice_endpoint: string,
  comment?: string,
  comment_phm?: string,
  budget_euro?: number,
}

export interface SingleJobResponse {
  object: SingleJob;
  hasErrors: boolean;
  message: string;
  errors: any[];
}

export class SingleJob {
  project_id: string = '';
  job_id: number = 0;
  offer_id: number = 0;
  company_name: string = '';
  department?: string = '';
  street: string = '';
  city: string = '';
  postcode: string = '';
  country: string = '';
  request_id: string = '';
  order_id: string = '';
  job_date: string = '';
  name_project: string = '';
  description: string = '';
  budget: string = '';
  cond_offer: number = 0;
  cond_payment: number = 0;
  cond_delivery: number = 0;
  delivery_remarks: string = '';
  delivery_date: string = '';
  status: string = '';
  employee_phm: number = 0;
  employee_leader: number = 0;
  technology: boolean = false;
  delivery_company: string = '';
  delivery_department?: string = '';
  delivery_street: string = '';
  delivery_postcode: string = '';
  delivery_city: string = '';
  delivery_country: string = '';
  invoice_company: string = '';
  invoice_department?: string = '';
  invoice_street: string = '';
  invoice_postcode: string = '';
  invoice_city: string = '';
  invoice_country: string = '';
  invoice_vat_id: string = '';
  invoice_leitweg_id: string = '';
  invoice_einvoice_endpoint: string = '';
  comment?: string = '';
  comment_phm?: string = '';
  budget_euro?: number = 0;
}

export interface JobsList {
  active: boolean,
  budget: string,
  comment?: string,
  comment_phm?: string,
  controlling_nr: string,
  delivery_date: string,
  delivery_remarks: string,
  description: string,
  has_child?: boolean,
  heat_nr: string,
  job_id: string,
  material: string,
  name: string,
  number_of_pieces: number,
  offer_id: number,
  part?: number,
  pieces_delivered: number,
  position: number,
  project_id: string,
  purchasing_price: string,
  remarks: string,
  selling_price: string,
  serial_nr: string,
  side_agreements?: string,
  specification?: string,
  status: string,
  taric?: string,
  technical_drawing: string,
  technology: boolean,
  weight: string,
}

export interface JobPositions {
  active?: boolean,
  budget?: number,
  comment_phm?: string,
  company_name: string,
  controlling_nr?: string,
  delivery_date?: string,
  description?: string,
  heat_nr?: string,
  job_id: string,
  material?: string,
  name: string,
  number_of_pieces: number,
  order_subject: string,
  part: number,
  position: string,
  ordercid: number,
  orderid: string,
  project_number?: string,
  remarks?: string,
  serial_nr?: string,
  side_agreements?: string,
  specification?: string,
  status: string,
  taric?: string,
  technical_drawing: string,
  technology?: boolean,
  weight?: string,
}

export interface JobPositionControlling {
  project_id: string;
  job_id: number;
  position: number;
  part: number;
  name: string;
  technical_drawing: string;
  offer_qty: number;
  offer_unit_price: number;
  offer_total: number;
  ek_qty: number;
  ek_unit_price: number;
  ek_total: number;
  vk_qty: number;
  vk_unit_price: number;
  vk_total: number;
  margin_total: number;
}
